module.exports = ".value-display .value.modified > *:first-child:after {\n  color: darkblue;\n  content: \"*\";\n  font-size: 0.5em;\n  margin-top: -1em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/value-display/value-display.component.less
// module id = ./src/app/shared/value-display/value-display.component.less
// module chunks = main